<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">{{ 'Settings::FtpIntegrationSourceName' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="organizationId">
    <label for="organizationId">{{ 'Settings::FtpIntegrationOrganizationId' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="organizationId"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="host">
    <label for="host">{{ 'Settings::FtpIntegrationHost' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="host" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="port">
    <label for="port">{{ 'Settings::FtpIntegrationPort' | abpLocalization }}</label>
    <input type="text" placeholder="21" class="form-control form-control-sm" id="port" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="username">
    <label for="username">{{ 'Settings::FtpIntegrationUsername' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="username" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="password">
    <label for="password">
      {{ 'Settings::FtpIntegrationPassword' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="password"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="useSftp">
    <input
      type="checkbox"
      id="useSftp"
      [(ngModel)]="useSftpCb"
      formControlName="value"/>
      <label class="ps-1" for="useSftp">
      {{ 'Settings::FtpIntegrationUseSftp' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="extension">
    <label for="extension">{{ 'Settings::FtpIntegrationExtension' | abpLocalization }}</label>
    <input type="text" placeholder=".csv" class="form-control form-control-sm" id="extension" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="path">
    <label for="path">{{ 'Settings::FtpIntegrationPath' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="path" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="errorPath">
    <label for="errorPath">{{ 'Settings::FtpIntegrationErrorPath' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="errorPath" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="ignoreFirstLine">
    <input
      type="checkbox"
      id="ignoreFirstLine"
      [(ngModel)]="ignoreFirstLineCb"
      formControlName="value"/>
      <label class="ps-1" for="ignoreFirstLine">
      {{ 'Settings::FtpIntegrationIgnoreFirstLine' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="template">
    <label for="template">{{ 'Settings::FtpIntegrationTemplate' | abpLocalization }}</label>
    <input type="text" placeholder="{callId},{agentId},{startTime:yyyy-MM-dd HH:mm:ss|yyyy-MM-dd},{-}" class="form-control form-control-sm" id="template" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="deleteMetadataFile">
    <input
      type="checkbox"
      id="deleteMetadataFile"
      [(ngModel)]="deleteMetadataFileCb"
      formControlName="value"/>
      <label class="ps-1" for="deleteMetadataFile">
      {{ 'Settings::FtpIntegrationDeleteMetadataFile' | abpLocalization }}
    </label>
  </div>
  <div class="form-group pt-2" formGroupName="deleteRecordingFile">
    <input
      type="checkbox"
      id="deleteRecordingFile"
      [(ngModel)]="deleteRecordingFileCb"
      formControlName="value"/>
      <label class="ps-1" for="deleteRecordingFile">
      {{ 'Settings::FtpIntegrationDeleteRecordingFile' | abpLocalization }}
    </label>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
